import { Link } from "react-router-dom";
import React from "react";

const Logo = () => (
  <Link to="/landing" className="cursor-pointer px-4 py-2 hover:text-accent-foreground">
    <div>
      <img src="/bloodline_logo_dot.svg" alt="Bloodline" className="h-8 w-auto relative top-[3px] sm:h-10" />
    </div>
  </Link>
);

export default Logo;
